import { API_BASE } from '@/utils/api-url'
import {
  AUTH_EXPIRED_ERROR_MESSAGE,
  clearWebsiteAuthSession,
  getHttpErrorMessage,
  getNetworkErrorMessage,
  isApiSuccess,
  isAuthExpiredResponse,
  readResponseJson
} from '@/utils/http-error'

/**
 * 获取当前登录用户信息，并统一处理认证失效和请求错误。
 * @returns {Promise<object>} 用户信息
 */
export async function getCurrentUserInfo() {
  const token = localStorage.getItem('dzzj_website_token')
  let response
  try {
    response = await fetch(`${API_BASE}/user/info`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    })
  } catch (error) {
    throw new Error(getNetworkErrorMessage(error))
  }
  const result = await readResponseJson(response)
  if (isAuthExpiredResponse(response, result)) {
    if (token) clearWebsiteAuthSession()
    throw new Error(getHttpErrorMessage(response, result, AUTH_EXPIRED_ERROR_MESSAGE))
  }
  if (!response.ok || !isApiSuccess(result)) {
    throw new Error(getHttpErrorMessage(response, result, '账号资料加载失败'))
  }
  return result.data
}
